import { l as y, N as u, g as f, a as N } from './consumer-BZtQu-UF.js';
import { b as h, d as w, c as x } from './consumer-BZtQu-UF.js';
const m = y.getChild('create');
function b(e, t, o, i, r, ...s) {
  const n = t[i];
  n && ((r = { ...r, meta: g(r, o) }), n.call(e, r, ...s));
}
async function T(e, t) {
  const o = { ...e.events },
    i = e.thisArg ?? null,
    r = e.isMeta ?? ((d) => !0),
    s = t ?? (await f()),
    n = v(e.config),
    p = E(e.content),
    c = s.createNoto(
      {
        type: e.type,
        // TODO - this would be 100% fine if going between threads, but until then,
        // it could allow secret updates to nested objects! can double-json to fix.
        meta: { ...e.meta },
        content: p,
        config: n,
      },
      b.bind(null, i, o, r),
    );
  return {
    ...c,
    close() {
      s.removeNoto(c.id, N.CREATOR);
    },
    update(d) {
      s.updateNoto(c.id, d);
    },
  };
}
function g(e, t) {
  let o = e.meta ?? {},
    i = !0;
  return (
    typeof o != 'object' ? ((i = !1), (o = {})) : t(e.meta) || (i = !1),
    i ||
      m.error(`Noto meta type=${e.type} id=${e.id} failed validation!`, e.meta),
    o
  );
}
function v(e = {}) {
  const t =
    typeof e.scopePriority == 'number'
      ? [e.scopePriority]
      : e.scopePriority ?? a.scopePriority;
  return {
    ttl: e.ttl ?? a.ttl,
    mergeRelated: e.mergeRelated ?? a.mergeRelated,
    scopePriority: t,
    requiresActive: e.requiresActive ?? a.requiresActive,
    requiresExplicitType: e.requiresExplicitType ?? a.requiresExplicitType,
    sameWindow: e.sameWindow ?? a.sameWindow,
  };
}
function E(e = {}) {
  const t = {
    title: e.title ?? l.title,
    body: e.body ?? l.body,
    // TODO - same concern here with shallow copy of actions, goes away post-tg
    actions: e.actions ?? l.actions,
    imageUrl: e.imageUrl ?? l.imageUrl,
    sound: e.sound ?? l.sound,
    vibrate: e.vibrate ?? l.vibrate,
  };
  return (
    t.body ||
      t.title ||
      m.warn('noto content should have body or title at least', { content: e }),
    t
  );
}
const a = {
    ttl: null,
    scopePriority: [u.INLINE, u.GLOBAL, u.SYSTEM],
    requiresActive: !0,
    mergeRelated: !1,
    sameWindow: !0,
    requiresExplicitType: !1,
  },
  l = {
    title: null,
    body: null,
    actions: [],
    imageUrl: null,
    sound: null,
    vibrate: !1,
  };
export {
  h as NotoAssignmentRejectionReason,
  N as NotoCloseReason,
  u as NotoDisplayScope,
  w as NotoManager,
  x as consumeNotos,
  T as createNoto,
  f as getNotoManager,
};
